import React, { useEffect, useState } from "react";
import { Modal} from "react-bootstrap";
import { FaShieldAlt } from "react-icons/fa";
import { IoIosUmbrella, IoIosInformationCircle } from "react-icons/io";
import { AiOutlineProduct } from "react-icons/ai";
import { AiOutlineFilePdf } from "react-icons/ai";

function getFilePreviewInfo(file) {
  if (file instanceof File) {
    return {
      previewUrl: URL.createObjectURL(file),
      fileName: file.name,
    };
  } else if (typeof file === "string") {
    return {
      previewUrl: file,
      fileName: file.split("/").pop() || "Unnamed File",
    };
  } else {
    return {
      previewUrl: null,
      fileName: "N/A",
    };
  }
}

const AssetImagePreview = ({ images = "" }) => {
  const [showModal, setShowModal] = useState(false);
  // const [selectedImage, setSelectedImage] = useState(images[0] || null);
  const displayImages = images.slice(0, 2);
  const remainingCount = images.length - 2;

  const openGallery = () => {
    // setSelectedImage(images[0] || null);
    setShowModal(true);
  };
  const closeGallery = () => setShowModal(false);

  return (
    <>
      <div className="d-flex flex-column h-100">
        {/* {displayImages.map((img, index) => (
          <div
            key={index}
            onClick={openGallery}
            style={{
              zIndex: 10 - index,
              marginLeft: index > 0 ? "-14px" : "0",
              cursor: "pointer",
            }}
          >
            <img
              src={img}
              alt={`asset-${index}`}
              className="rounded-3 border"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
              }}
            />
          </div>
        ))}

        {remainingCount > 0 && (
          <div
            onClick={openGallery}
            className="rounded-3 border bg-light text-dark d-flex align-items-center justify-content-center fw-bold"
            style={{
              width: "50px",
              height: "50px",
              marginLeft: "-14px",
              cursor: "pointer",
              zIndex: 5,
            }}
          >
            +{remainingCount}
          </div>
        )} */}
        {/* <div
          className="flex-fill"
          style={{ height: "140px", width: "100%" }}
          onClick={() => setShowModal(true)}
        >
          {selectedImage ? (
            <img
              src={selectedImage}
              alt="Selected"
              className="rounded-4 shadow-sm border"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <div className="text-muted">No image selected</div>
          )} */}
        <img
          src={images}
          alt="Selected"
          className="rounded-4 shadow-sm border img-fluid"
        />
      </div>
      {/* <div
        className="scroll-container d-flex gap-1 justify-content-center"
        style={{
          overflowX: "auto",
          padding: "4px 0",
        }}
      >
        {images.map((img, idx) => {
            const isSelected = selectedImage === img;
            return (
              <img
                key={idx}
                src={images}
                alt={`thumb-${idx}`}
                onClick={() => setSelectedImage(img)}
                style={{
                  width: "28px",
                  height: "28px",
                  objectFit: "cover",
                  cursor: "pointer",
                  opacity: isSelected ? 1 : 0.5,
                  transform: isSelected ? "scale(1.05)" : "scale(1)",
                  border: isSelected ? "2px solid #007bff" : "1px solid #ccc",
                  boxShadow: isSelected
                    ? "0 0 8px rgba(0,123,255,0.4)"
                    : "none",
                  transition: "all 0.25s ease",
                  flexShrink: 0,
                }}
              />
            );
          })}
      </div> */}
      <Modal
        show={showModal}
        onHide={closeGallery}
        size="lg"
        centered
        className="overflow-hidden"
      >
        <Modal.Header closeButton>
          <Modal.Title>Asset Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="d-flex" style={{ maxHeight: "500px" }}>
            {/* Left Thumbnails */}
            {/* <div
              className="d-flex flex-column align-items-start gap-2 pe-3"
              style={{
                overflowY: "auto",
                maxHeight: "500px",
                borderRight: "1px solid #ddd",
                className: "scroll-container",
              }}
            >
              {images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  onClick={() => setSelectedImage(img)}
                  alt={`thumb-${idx}`}
                  className={`border rounded-3 ${
                    selectedImage === img ? "border-primary" : ""
                  }`}
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    cursor: "pointer",
                    borderWidth: selectedImage === img ? "2px" : "1px",
                    boxShadow:
                      selectedImage === img
                        ? "0 0 10px rgba(0, 123, 255, 0.7)"
                        : "none",
                    transition: "0.2s",
                  }}
                />
              ))}
            </div> */}

            <div className="flex-grow-1 d-flex justify-content-center align-items-center">
              {/* {selectedImage ? ( */}
              <img
                src={images}
                alt="Selected"
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
              {/* // ) : (
                 <div className="text-muted">No image selected</div>
               )} */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const TABS = [
  {
    key: "basic",
    label: "Basic Details",
    icon: <IoIosInformationCircle className="me-1" />,
  },
  {
    key: "warranty",
    label: "Warranty & Service",
    icon: <FaShieldAlt className="me-1" />,
  },
  {
    key: "insurance",
    label: "Insurance",
    icon: <IoIosUmbrella className="me-1" />,
  },
];

const InfoRow = ({ type, label, value }) => (
  <div
    className={`rounded-3 px-2 py-1 ${
      type === "basic"
        ? "basic-box"
        : type === "warranty"
        ? "warranty-box"
        : type === "insurance"
        ? "insurance-box"
        : "grndetails-box"
    }`}
  >
    <span
      className={`fw-medium ${
        type === "basic"
          ? "text-info"
          : type === "warranty"
          ? "text-success"
          : type === "insurance"
          ? "text-warning"
          : "text-dark"
      }`}
      style={{ fontSize: "0.8rem" }}
    >
      {label}
    </span>
    <br></br>{" "}
    <span className="text-darker fw-medium" style={{ fontSize: "0.9rem" }}>
      {value || "-"}
    </span>
  </div>
);

const TabSection = ({ asset, activeTab }) => {
  const { previewUrl: warentyUrl, fileName: warentyFileName } =
    getFilePreviewInfo(asset?.warrantyFile);
  const { previewUrl: insuranceUrl, fileName: insuranceFileName } =
    getFilePreviewInfo(asset?.insuranceFile);

  switch (activeTab) {
    case "basic":
      return (
        <div className="row g-3">
          <div className="col-md-9">
            <div className="row g-2">
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Purchase Date"
                  value={asset?.purchaseDate || "N/A"}
                />
              </div>
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Brand"
                  value={asset?.brand || "N/A"}
                />
              </div>
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Model Number"
                  value={asset?.modelNumber || "N/A"}
                />
              </div>
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Serial Number"
                  value={asset?.serialNumber || "N/A"}
                />
              </div>
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Catagory"
                  value={asset?.catagory?.label || "N/A"}
                />
              </div>
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Sub-Catagory"
                  value={asset?.sub_catagory?.label || "N/A"}
                />
              </div>
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Other Information"
                  value={asset?.other_info || "N/A"}
                />
              </div>
              <div className="col-md-4">
                <InfoRow
                  type="basic"
                  label="Manufacturer"
                  value={asset?.manufacturer || "N/A"}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            {asset?.image && (
              <AssetImagePreview
                images={
                  typeof asset?.image === "string"
                    ? asset?.image
                    : URL.createObjectURL(asset?.image)
                }
              />
            )}
          </div>
        </div>
      );
    case "warranty":
      return (
        <div className="row g-3">
          <div className="col-md-3">
            <InfoRow
              type="warranty"
              label="Service Cycle"
              value={asset?.serviceCycle || "N/A"}
            />
          </div>
          <div className="col-md-3">
            <InfoRow
              type="warranty"
              label="Expected Life Span"
              value={asset?.serviceCycle || "N/A"}
            />
          </div>
          <div className="col-md-3">
            <InfoRow
              type="warranty"
              label="Warranty End"
              value={asset?.lifespan || "N/A"}
            />
          </div>
          <div className="col-md-3">
            <InfoRow
              type="warranty"
              label="Deprecition Rate"
              value={asset?.depreciationRate || "N/A"}
            />
          </div>

          <div className="col-md-3">
            <InfoRow
              type="warranty"
              label="Scrap value"
              value={asset?.scrapValue || "N/A"}
            />
          </div>

          <div className="col-md-3">
            <InfoRow
              type="warranty"
              label="Warranty File"
              value={
                asset?.warrantyFile ? (
                  <a
                    href={warentyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center gap-1 text-decoration-none text-primary"
                  >
                    <AiOutlineFilePdf size={18} className="text-danger" />
                    <span className="text-darker fw-medium">
                      {warentyFileName}
                    </span>
                  </a>
                ) : (
                  "-"
                )
              }
            />
          </div>
        </div>
      );
    case "insurance":
      return (
        <div className="row g-3">
          <div className="col-md-3">
            <InfoRow
              type="insurance"
              label="Insurance Provider"
              value={asset?.insuranceProvider || "N/A"}
            />
          </div>
          <div className="col-md-3">
            <InfoRow
              type="insurance"
              label="Policy Number"
              value={asset?.policyNumber || "N/A"}
            />
          </div>
          <div className="col-md-3">
            <InfoRow
              type="insurance"
              label="Insurance Expiry"
              value={asset?.insuranceExpiry || "N/A"}
            />
          </div>
          <div className="col-md-3">
            <InfoRow
              type="insurance"
              label="Insurance File"
              value={
                asset.insuranceFile ? (
                  <a
                    href={insuranceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center gap-1 text-decoration-none text-primary"
                  >
                    <AiOutlineFilePdf size={18} className="text-danger" />
                    <span className="text-darker fw-medium">
                      {insuranceFileName}
                    </span>
                  </a>
                ) : (
                  "-"
                )
              }
            />
          </div>
        </div>
      );
    default:
      return null;
  }
};

const AssetCard = ({ asset }) => {
  const [activeTab, setActiveTab] = useState("basic");

  return (
    <div className="card mb-3 shadow-sm overflow-hidden">
      <div className="d-flex justify-content-between align-items-center text-bg-info-soft p-3">
        <div className="d-flex align-items-center gap-2 flex-fill">
          <span className="bg-info rounded-3" style={{ padding: "0.7% 1.2%" }}>
            <AiOutlineProduct className="text-white" />
          </span>
          <div>
            <h5 className="text-darker m-0" style={{ fontSize: "1.23rem" }}>
              {asset?.assetName || "N/A"}
            </h5>
            <p className="text-dark fw-medium" style={{ fontSize: "0.8rem" }}>
              Asset ID: {asset?.assetId || "N/A"}
            </p>
          </div>
        </div>
        <div className="text-end">
          <h4 className="text-darker m-0" style={{ fontSize: "1.2rem" }}>
            {`₹${asset?.purchaseCost}` || "N/A"}
          </h4>
          <div className="text-dark fw-medium" style={{ fontSize: "0.8rem" }}>
            Purchase Cost
          </div>
        </div>
      </div>

      <div className="card-body">
        <ul className="nav flex-row custom-nav1 mb-4">
          {TABS.map((tab) => (
            <li className="nav-item" key={tab.key}>
              <span
                className={`rounded-pill nav-link ${
                  activeTab === tab.key ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.key)}
                style={{ cursor: "pointer" }}
              >
                {tab.icon} {tab.label}
              </span>
            </li>
          ))}
        </ul>
        <TabSection asset={asset} activeTab={activeTab} />
      </div>
    </div>
  );
};

const AssetAddPreview = ({ show, onClose, asset }) => {

  return (
    <Modal show={show} onHide={onClose} size="xl" centered scrollable>
      <Modal.Header closeButton className="py-2 ps-2 pe-4">
        <div>
          <h5 className="modal-title">Asset Info</h5>
          <small className="text-small">
            Goods Receipt Assets
          </small>
        </div>
      </Modal.Header>

      <Modal.Body className="scroll-container p-3">

        {asset?.map((asset, idx) => (
          <AssetCard asset={asset} key={idx} />
        ))}
      </Modal.Body>

      <Modal.Footer>
        <span
          className="btn rounded-2 stylish-transparent-btn"
          onClick={onClose}
        >
          Close
        </span>
      </Modal.Footer>
    </Modal>
  );
};

export default AssetAddPreview;
